<div class="d-flex justify-content-center align-items-center">
    <div class="text-container">
        <h5>Stai per avviare l'operazione per l'annullamento {{ operationDescription }}.</h5>
        <h5>Cliccando su <span class="text-red">Avanti</span>, confermerai l'esecuzione di tale operazione.</h5>
    </div>
</div>